export default __webpack_public_path__ + "static/media/home-icon-bottom-nav-mobile-active.470e93db.webp";